/**
 * Use this function to force exhaustiveness checking.
 *
 * See: https://stackoverflow.com/a/39419171
 */
export const assertNever = (_: never): never => {
  throw new Error('Invariant Violation: unreachable code detected');
};
